module.exports = __webpack_public_path__ + "static/media/bg.19128146.jpg";